/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LETTER_TEMPLATE_JOB_TYPE, LETTER_TEMPLATE_SYSTEM_TYPE } from '@gh/builder-shared-data';
import { createRoute } from '@gh/builder-shared';
import { LetterTemplateTabContainerComponent } from './components/letter-template-tab-container/letter-template-tab-container.component';
import { LetterTemplateListTabComponent } from './components/letter-template-tab/letter-template-list-tab.component';
import { LetterTemplateBusinessService } from './resources/letter-template-business.service';

const routes = [
  createRoute({
    component: LetterTemplateTabContainerComponent,
    path: '',
    children: [
      createRoute({
        component: LetterTemplateListTabComponent,
        init: LetterTemplateBusinessService,
        path: 'system',
        static: {
          type: LETTER_TEMPLATE_SYSTEM_TYPE,
        },
        auth: {
          permission: ['Setup.ManageTemplates.SystemLetters.ANY'],
        },
      }),
      createRoute({
        component: LetterTemplateListTabComponent,
        path: 'job',
        init: LetterTemplateBusinessService,
        static: {
          type: LETTER_TEMPLATE_JOB_TYPE,
        },
        auth: {
          permission: ['Setup.ManageTemplates.JobLetters.ANY'],
        },
      }),
    ],
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupLetterTemplatesRoutingModule {

}
